import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon/index';

function AsyncButton(props) {
  const {
    loading,
    onClick,
    className,
    children,
    spinner,
    disabled,
    id,
    onKeyDown,
  } = props;
  return (
    <button
      disabled={loading || disabled}
      onClick={onClick}
      className={className}
      id={id}
      onKeyDown={onKeyDown}
    >
      {
        spinner &&
        <Icon name="fa-spinner fa-spin" style={{ marginRight: 5 }} />
      }
      {children}
    </button>
  );
}

AsyncButton.propTypes = {
  spinner: PropTypes.bool,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.any,
  onKeyDown: PropTypes.any,
};

export default AsyncButton;



// WEBPACK FOOTER //
// ./app/components/AsyncButton/index.js